import endpoints from './endpoints'

export { getReq, postReq, deleteSendReq, putReq, exportExcelReq, exportExcelGetReq, getCPHeaderMap, getHeaderCodeMap } from './methods'
export const END_POINTS = endpoints



// WEBPACK FOOTER //
// ./src/api/index.js